function r(o){return typeof o=="symbol"}export{r as a};
